import { LocalStorageKey } from 'shared/entities/localStorage';

export enum OnboardingStep {
  channelCreate = 'channelCreate',
  scenarioCreate = 'scenarioCreate',
  botCapabilities = 'botCapabilities',
  botCreationDemo = 'botCreationDemo'
}

export type OnboardingStepId = OnboardingStep;

/** UI порядок шагов онбординга (первый незавершенный шаг активен). */
export const onboardingStepsUiOrder = [
  OnboardingStep.channelCreate,
  OnboardingStep.scenarioCreate,
  OnboardingStep.botCapabilities,
  OnboardingStep.botCreationDemo
] as const;

export const STEP_LS_KEYS: Record<OnboardingStep, LocalStorageKey> = {
  channelCreate: LocalStorageKey.onboardingStepChannelCreateCompleted,
  scenarioCreate: LocalStorageKey.onboardingStepScenarioCreateCompleted,
  botCapabilities: LocalStorageKey.onboardingStepBotCapabilitiesCompleted,
  botCreationDemo: LocalStorageKey.onboardingStepBotCreationDemoCompleted
};

/** Маркер в sessionStorage для delayed attribution (`*_after_onboarding`). */
export type OnboardingAfterPendingState = {
  startedAt: number;
};
